import { Router } from '@angular/router';
import { LoginService } from '../core/login.service';

export function appInitializer(authenticationService: LoginService, router: Router) {
    return () => new Promise(resolve => {
        if (window.location.href.includes('/privacy-policy')) {
            resolve(true);
        } else {
            // attempt to refresh token on app start up to auto authenticate
            authenticationService.refreshToken()
                .subscribe((data) => {
                    resolve(true)
                }, (err) => {
                    console.log(err)
                    authenticationService.logout();
                    resolve(true)
                })
        }
    });
}